import PWAPromptModal from './PWAPromptModal';

export default PWAPromptModal;
